import { useState } from "react";
import { initPasswordReq } from "../init/MypageInit";
import { initValidation } from '../../../common/init/CommonInit';
import { Modal } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { updateUserPasswordApi } from "../../../../api/account/AccountApi";

interface PwModalProps {
    isShow: boolean; // 모달 표시 여부
    onClose: () => void; // 모달 닫기 콜백
    userId : number;
    setIsSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PwModal = ({ isShow, onClose, userId, setIsSuccess }: PwModalProps) => {

    const [show, setShow] = useState(isShow);

    const [validation, setValidation] = useState(initValidation);

    const [passwordReq, setPasswordReq] = useState(initPasswordReq);
    
    const edit = () => {

        if(passwordReq.password === "" || passwordReq.newPassword === "" || passwordReq.newPasswordChk === ""){
            setValidation({...validation, isInput : true});
            return;
        }

        if(passwordReq.newPassword !== passwordReq.newPasswordChk) {
            setValidation({...validation, isSame : true});
            return;
        }

        if(passwordReq.password === passwordReq.newPassword) {
            setValidation({...validation, isBoth : true});
            return;
        }

        passwordReq.userId = userId

        updatePasswordApiMutate.mutate(passwordReq)
    }

    const updatePasswordApiMutate = useMutation({
        mutationFn: (data:any) => updateUserPasswordApi(data),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setIsSuccess(true)
                onClose()
            } else {
                setValidation({...validation, isValid : true});
                return;
            }
        },
        onError: res => {
            alert(res)
        }
    });

    return (

        <Modal className="my_modal" show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>비밀번호 수정</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="modal_text">새 비밀번호를 공백을 제외한 숫자, 문자, 특수문자를 이용하여 입력해주십시오.</p>
                    <input placeholder="현재 비밀번호*" 
                            type="password" 
                            className="form-control modal_input_pw" 
                            value={passwordReq.password || ""}
                            onChange={(e) => setPasswordReq({...passwordReq, password : e.target.value})}
                    />
                    <input placeholder="새 비밀번호*" 
                            type="password" 
                            className="form-control modal_input_pw" 
                            value={passwordReq.newPassword || ""}
                            onChange={(e) => setPasswordReq({...passwordReq, newPassword : e.target.value})}
                            />
                    <input placeholder="새 비밀번호 확인*" 
                            type="password" 
                            className="form-control modal_input_pw"
                            value={passwordReq.newPasswordChk || ""}
                            onChange={(e) => setPasswordReq({...passwordReq, newPasswordChk : e.target.value})}
                    />
                    {   
                        validation.isValid ? 
                        <div className="error-messageLogin">현재 비밀번호가 일치하지 않습니다.</div> :
                        validation.isSame ?
                        <div className="error-messageLogin">새 비밀번호 확인이 일치하지 않습니다. </div> :
                        validation.isInput ?
                        <div className="error-messageLogin">현재 비밀번호 혹은 새 비밀번호를 입력해주십시오.</div> : 
                        validation.isBoth ?
                        <div className="error-messageLogin">이전 비밀번호와 동일하게 변경 할 수 없습니다.</div> : ""
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary w-100px h-38px" onClick={onClose}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />
                        닫기
                    </button>
                    <button type="button" className="btn btn-secondary w-100px h-38px" onClick={()=>edit()}>수정</button>
                </Modal.Footer>
            </Modal>
    )
}